import React, {memo} from 'react';
import AdminHeader from '@/components/TableGrid/TableHeader';
import PropTypes from 'prop-types';
import TableData from '@/components/TableGrid/TableData';
import {Card} from 'antd';
import {TableContextProvider} from '@/contexts/tableGridContact';
import EntityMenu from '@/components/EntityMenu';
import {useDialogsContext} from '@/contexts/DialogsContext';
import {ADD_HANDLER_DIALOG} from '@/utils/createEntityContainer';

const TableGrid = ({
  tableTitle,
  extras,
  columns,
  useTableData,
  canSelect,
  rowActions,
  actionsLabel,
  addLabel,
  translation,
  selectedActions,
  filters,
  canAdd,
  route,
  useCreatePath,
  useMapColumns,
  searchPlaceholder,
  canSearch,
  hasTable = true,
  actionsViewByRoute,
  actions,
  onAddModalName,
  showTitle,
  withDynamicColumns,
  useDynamicColumns = () => ({cols: []}),
  customHeader,
  customTitle,
  module,
  ...props
}) => {
  const {openDialog} = useDialogsContext(onAddModalName || module || ADD_HANDLER_DIALOG);

  const {cols} = useDynamicColumns();

  if (rowActions && !columns.some(c => c.dataIndex === 'actions')) {
    columns.push(
      {
        title: actionsLabel,
        dataIndex: 'actions',
        width: 100,
        align: 'center',
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
          <EntityMenu data={record}/>
        )
      }
    );
  }

  return (
    <Card className={'responsive-card w-full'}>
      <TableContextProvider columns={withDynamicColumns ? cols : columns} translation={translation} useMapColumns={useMapColumns}>
        <AdminHeader
          title={customTitle || tableTitle}
          onAdd={() => openDialog()}
          useCreatePath={useCreatePath}
          route={route}
          addLabel={addLabel}
          extras={extras}
          hasTable={hasTable}
          canAdd={canAdd}
          canSearch={canSearch}
          filters={filters}
          translation={translation}
          searchPlaceholder={searchPlaceholder}
          actionsViewByRoute={actionsViewByRoute}
          actions={actions}
          showTitle={showTitle}
          customHeader={customHeader}
          module={module}
        />
        <TableData
          selectedActions={selectedActions}
          tableHook={useTableData}
          canSelect={canSelect}
          {...props}/>
      </TableContextProvider>
    </Card>
  );

};

TableGrid.propTypes = {
  actionsLabel: PropTypes.string,
  addLabel: PropTypes.string,
  canSelect: PropTypes.bool,
  canSearch: PropTypes.bool,
  hasTable: PropTypes.bool,
  columns: PropTypes.array,
  extras: PropTypes.node,
  filters: PropTypes.any,
  onAdd: PropTypes.func,
  route: PropTypes.string,
  rowActions: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  selectedActions: PropTypes.func,
  tableHook: PropTypes.func,
  tableTitle: PropTypes.string.isRequired,
  customTitle: PropTypes.any,
  translation: PropTypes.string,
  translationPrefix: PropTypes.string,
  useCreatePath: PropTypes.bool,
  useTableData: PropTypes.func.isRequired,
  canAdd: PropTypes.bool,
  useMapColumns: PropTypes.any,
  searchPlaceholder: PropTypes.any,
  actionsViewByRoute: PropTypes.bool,
  actions: PropTypes.array,
  onAddModalName: PropTypes.string,
  showTitle: PropTypes.bool,
  showHeaderCard: PropTypes.bool,
  withDynamicColumns: PropTypes.bool,
  useDynamicColumns: PropTypes.func,
  customHeader: PropTypes.any,
  module: PropTypes.string,
};

TableGrid.defaultProps = {
  canAdd: true,
  canSearch: true,
  showTitle: true,
};

export default memo(TableGrid);
